import {
  Box,
  Typography as Typo,
  TypographyProps,
  Paper,
  Divider,
  Grid,
  Tooltip,
  IconButton,
  useTheme,
  Link as MuiLink,
  styled,
} from '@mui/material';
import Button from '@jobseeker/lotus/elements/Button';
import {
  FaBookmark,
  FaInfo,
  FaStar,
  FaRegStar,
  FaBriefcase,
  FaPlusCircle,
  FaMapMarkerAlt,
  FaRegCalendar,
  FaTimes,
  FaBan,
} from 'react-icons/fa';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';
import {colorPalette, mainColor} from '@jobseeker/lotus/foundations';
import {useState} from 'react';

import type {JobListProps} from '../type';
import dayjs from 'dayjs';

// import {  } from '@emotion/react';

// export interface ClassicjobListProps {}
const Link = styled(MuiLink)(props => ({
  textDecoration: 'none',
  color: props.theme.palette.secondary.main,
  cursor: 'pointer',
  // '*': {
  //   fontWeight: '800',
  // },
  ':hover': {
    color: props.theme.palette.error.dark,
  },
}));
const Typography = styled(Typo)<any>((props: any) => ({
  display: 'flex',
  alignItems: 'center',
  // gap: '5px',
}));

const ClassicJobList = (props: JobListProps) => {
  const [dropDown, setDropDown] = useState<boolean>(false);
  const ICON_SIZE = 14;
  const IsLarge = useIsLargeDevice('sm');
  const theme = useTheme();
  const pxToRem = theme.typography.pxToRem;
  const {isCompanyJob, isPremiumJob, isSaved, additionalInfo, noShadow} = props;
  const [saved, setSaved] = useState<boolean>(!!isSaved);
  const [hideJob, setHideJob] = useState<boolean>(false);
  const [hideRecruiter, setHideRecruiter] = useState<boolean>(false);
  const [loadingElement, setLoadingElement] = useState<string>('');

  const toggleDropDown = (event: any) => {
    event?.stopPropagation();
    setDropDown(!dropDown);
  };

  const onSaveClick = (event: any) => {
    event?.stopPropagation();
    setSaved(!saved);
    if (props.onSaveClick) {
      props.onSaveClick(props.jobData, saved);
    }
  };

  const onHideJobClick = (event: any) => {
    event?.stopPropagation();
    setHideJob(!hideJob);
    setLoadingElement('JOB');
    setTimeout(() => {
      setLoadingElement('');
    }, 1000);
    if (props.onJobActionClick) {
      props.onJobActionClick(props.jobData, 'JOB');
    }
  };

  const onHideRecruiterClick = (event: any) => {
    event?.stopPropagation();
    setHideRecruiter(!hideRecruiter);

    setLoadingElement('RECRUITER');
    setTimeout(() => {
      setLoadingElement('');
    }, 1000);
    if (props.onJobActionClick) {
      props.onJobActionClick(props.jobData, 'RECRUITER');
    }
  };

  const onUndoJobHide = (event: any) => {
    event?.stopPropagation();
    setHideJob(!hideJob);
    setLoadingElement('JOB');
    setTimeout(() => {
      setLoadingElement('');
    }, 1000);
    if (props.onUndoActionClick) {
      props.onUndoActionClick(props.jobData, 'JOB');
    }
  };

  const onUndoRecruiterHide = (event: any) => {
    event?.stopPropagation();
    setHideRecruiter(!hideRecruiter);

    setLoadingElement('RECRUITER');
    setTimeout(() => {
      setLoadingElement('');
    }, 1000);
    if (props.onUndoActionClick) {
      props.onUndoActionClick(props.jobData, 'RECRUITER');
    }
  };

  const onJobClick = (event: any) => {
    // alert('test');
    event?.stopPropagation();
    if (props.onJobClick) {
      props.onJobClick(props.jobData);
    }
  };

  // const onSaveClick = () => {
  //   setSaved(!saved);
  //   if (props.onSaveClick) {
  //     props.onSaveClick(props);
  //   }
  // };

  return (
    <Box onClick={onJobClick} color="gray.dark">
      <Paper
        elevation={noShadow ? 0 : 1}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          borderRadius: noShadow ? 0 : 2,
          py: 1,
          px: 1.5,
          pr: 6,
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          cursor: 'pointer',
          transition: 'all ease 0.3s',
          '.cross-button': {
            opacity: 0,
          },
          ':hover': {
            backgroundColor: '#f5f6f7',
            '.cross-button': {
              opacity: 1,
            },
          },

          ...props.sx,
        }}
      >
        <Grid container>
          <Grid item xxs={12} sm={9}>
            <Box sx={{display: 'flex'}}>
              {IsLarge && (
                <Box
                  sx={{
                    display: 'flex',
                    color: colorPalette.white.A150,
                    // gap: 'px',
                    pr: 2,
                  }}
                >
                  <Tooltip title={isCompanyJob && 'Company Job'}>
                    <IconButton
                      size="small"
                      sx={{
                        fontSize: pxToRem(ICON_SIZE),
                        color: isCompanyJob ? '#000' : 'inherit',
                      }}
                    >
                      <FaBriefcase />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={isPremiumJob && 'Premium Job'}>
                    <IconButton
                      size="small"
                      sx={{
                        fontSize: pxToRem(ICON_SIZE),
                        color: isPremiumJob ? '#000' : 'inherit',
                      }}
                    >
                      <FaBookmark />
                    </IconButton>
                  </Tooltip>
                  <Tooltip
                    title={
                      additionalInfo?.length && additionalInfo[0].icon
                        ? additionalInfo.label
                        : additionalInfo
                    }
                  >
                    <IconButton
                      size="small"
                      sx={{
                        fontSize: pxToRem(ICON_SIZE),
                        color: additionalInfo ? '#000' : 'inherit',
                      }}
                    >
                      <FaPlusCircle />
                    </IconButton>
                  </Tooltip>
                  <Tooltip
                    title={
                      saved ? 'You Saved this job' : 'Save this Job for Future'
                    }
                  >
                    <IconButton
                      size="small"
                      sx={{
                        fontSize: pxToRem(ICON_SIZE),
                        ':hover': {
                          color: mainColor.yellow,
                        },
                        color: saved ? mainColor.yellow : 'inherit',
                      }}
                      onClick={onSaveClick}
                    >
                      {!saved ? <FaRegStar /> : <FaStar />}
                    </IconButton>
                  </Tooltip>
                </Box>
              )}
              <Box>
                <Typography
                  component={'p'}
                  sx={{
                    fontSize: IsLarge ? pxToRem(14) : pxToRem(14),
                  }}
                >
                  {props.title}
                </Typography>
                {!IsLarge && (
                  <Typography
                    component={'p'}
                    sx={{
                      fontSize: pxToRem(12),
                      display: 'flex',
                      gap: '20px',
                      color: colorPalette.black['A100'],
                      pt: 1,
                    }}
                  >
                    <span>
                      <FaRegCalendar /> {props.experiance}
                    </span>
                    <span>
                      <FaMapMarkerAlt /> {props.location}
                    </span>
                  </Typography>
                )}
              </Box>
            </Box>
          </Grid>
          {IsLarge && (
            <>
              <Grid
                item
                xxs={1.5}
                // lg={1}
                sx={{textAlign: 'left', overflow: 'hidden'}}
              >
                <Typography
                  component={'p'}
                  variant="body1"
                  sx={{
                    fontWeight: '500',
                    fontSize: pxToRem(14),
                    wordBreak: 'break-all',
                  }}
                >
                  {props.location}
                </Typography>
              </Grid>
              <Grid item xxs={1.5} sx={{textAlign: 'right'}}>
                <Typography
                  component={'p'}
                  variant="body1"
                  sx={{fontWeight: '500', fontSize: pxToRem(14)}}
                >
                  {dayjs(props.date).format('DD/MM/YYYY')}
                </Typography>
              </Grid>
            </>
          )}
        </Grid>
        <Box sx={{position: 'relative'}} className="cross-button">
          <IconButton
            size="small"
            sx={{
              fontSize: pxToRem(ICON_SIZE),
              position: 'absolute',
              right: -35,
              top: -13,
              color: theme.palette.gray.dark,
            }}
            onClick={toggleDropDown}
          >
            <FaTimes />
          </IconButton>
        </Box>
      </Paper>
      {dropDown && (
        <Paper
          elevation={noShadow ? 0 : 1}
          sx={{
            borderRadius: '0 0 5px 5px',
            // border: '1px solid #000',
            p: theme.spacing(1, 2),
          }}
        >
          {loadingElement == 'JOB' ? (
            <Typography variant="subtitle2">Wait ....</Typography>
          ) : hideJob ? (
            <Typography variant="subtitle2">
              We will not show you this job posting again.&nbsp;&nbsp;
              <MuiLink sx={{cursor: 'pointer'}} onClick={onUndoJobHide}>
                Undo
              </MuiLink>
            </Typography>
          ) : (
            <Link onClick={onHideJobClick}>
              <Typography variant="subtitle2">
                <Typography component={'i'} variant="subtitle1">
                  <FaTimes />
                </Typography>
                &nbsp;&nbsp; Please don't show me this job posting again.
              </Typography>
            </Link>
          )}
          {loadingElement == 'RECRUITER' ? (
            <Typography variant="subtitle2">Wait ....</Typography>
          ) : hideRecruiter ? (
            <Typography variant="subtitle2">
              We will not show you any jobs posted by this
              recruiter.&nbsp;&nbsp;
              <MuiLink sx={{cursor: 'pointer'}} onClick={onUndoRecruiterHide}>
                Undo
              </MuiLink>
            </Typography>
          ) : (
            <Link onClick={onHideRecruiterClick}>
              <Typography variant="subtitle2">
                <Typography component={'i'} variant="subtitle1">
                  <FaBan />
                </Typography>
                &nbsp;&nbsp;Please don't show me any jobs posted by this
                recruiter.
              </Typography>
            </Link>
          )}
          <Box sx={{position: 'relative'}} className="cross-button">
            <IconButton
              size="small"
              sx={{
                fontSize: pxToRem(ICON_SIZE),
                position: 'absolute',
                right: -5,
                top: -33,
                color: theme.palette.gray.dark,
              }}
              onClick={toggleDropDown}
            >
              <FaTimes />
            </IconButton>
          </Box>
        </Paper>
      )}
    </Box>
  );
};

export default ClassicJobList;
